import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {PortfolioModel} from '../../../../shared/models/portfolio.model';
import { MaterialModule } from 'src/app/app.materials';
import { NavListComponent } from '../nav-list/nav-list.component';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MaterialModule, NavListComponent]
})
export class SidenavComponent implements OnInit {
  @Output() sidenavClose = new EventEmitter();
  @Input() portfolio = new PortfolioModel({});
  @Input() isAdmin = false;

  constructor() { }

  ngOnInit(): void {
  }

  public onSidenavClose = () => {
    this.sidenavClose.emit();
  }

}
